
import { Menu } from 'lucide-react';
import CartButton from './CartButton';

type MobileMenuButtonProps = {
  isMenuOpen: boolean;
  toggleMenu: () => void;
};

const MobileMenuButton = ({ isMenuOpen, toggleMenu }: MobileMenuButtonProps) => {
  return (
    <div className="md:hidden flex items-center">
      <div className="mr-4">
        <CartButton />
      </div>
      <button 
        className="text-foreground p-2 rounded-md hover:bg-gray-100" 
        onClick={toggleMenu} 
        aria-label="Open menu"
      >
        <Menu className="h-6 w-6" />
      </button>
    </div>
  );
};

export default MobileMenuButton;
